<template>
  <fragment>
    <v-row>
      <v-col cols="6">
        <v-btn
          width="100%"
          :class="['rounded-lg']"
          @click="openDescriptionModal"
        >
          <!-- :color="f ? '' : 'white'" adicionar ao btn acima -->
          <!-- , descriptionEmpty && 'description-product' adicionar a classe dinamica acima -->
          <v-icon left v-if="descriptionIsNotEmpty" color="green"
            >mdi-text-box-check-outline</v-icon
          >
          <v-icon left v-else>mdi-text-box-remove-outline</v-icon>
          <span class="desc"> Insira aqui a descrição </span>
        </v-btn>
        <!-- <div class="v-text-field__details mt-2 px-3" v-if="descriptionEmpty">
          <div class="v-messages theme--light error--text">
            <div class="v-messages__wrapper">
              <div class="v-messages__message">
                <span>Preencha a descrição do produto corretamente!</span>
              </div>
            </div>
          </div>
        </div> -->
      </v-col>
      <v-col cols="6">
        <BaseSelect
          required
          tabindex="1"
          label="Status"
          item-text="value"
          item-value="key"
          :placeholder="statusPlaceholder"
          :clearable="false"
          :rules="[rules.required]"
          :items="$produtos_gerenciar.status_produtos"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.status"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseSelect
          required
          tabindex="2"
          label="Categoria"
          item-text="descricao"
          item-value="idcategoria"
          placeholder="Selecione uma categoria"
          :clearable="false"
          :rules="[rules.required]"
          :items="$produtos_gerenciar.categorias_produtos"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.categoria"
        />
      </v-col>
      <v-col v-if="!isCourtesyProduct">
        <BaseMoneyField
          required
          tabindex="3"
          label="Preço"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.preco"
        />
      </v-col>
      <v-col v-if="isCourtesyProduct">
        <BaseMoneyField
          tabindex="3"
          label="Preço"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.preco"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseMoneyField
          tabindex="4"
          label="Preço Promocional"
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.preco_promocional
          "
        />
      </v-col>
      <v-col cols="6">
        <BaseSelect
          clearable
          label="Tag"
          item-text="key"
          item-value="value"
          placeholder="Selecione as tags"
          :items="tags"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.tags"
          @click:clear="$produtos_gerenciar.cadastro.dados_cadastrais.tags = []"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseTextField
          label="Local do evento"
          placeholder="Insira o local do evento"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.endereco"
        />
      </v-col>
      <v-col cols="6">
        <BaseAutocomplete
          label="País"
          item-text="dsc_lang"
          return-object
          placeholder="Selecione o país"
          autocomplete="null"
          auto-select-first
          :loading="$config.loading_paises"
          :items="$config.paises.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.pais"
        >
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseAutocomplete
          label="Estado"
          item-text="dsc_lang"
          item-value="iso_full"
          return-object
          placeholder="Selecione o estado"
          autocomplete="null"
          auto-select-first
          :loading="$config.loading_estados"
          :items="$config.estados.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.estado"
        >
        </BaseAutocomplete>
      </v-col>
      <v-col cols="6">
        <BaseAutocomplete
          label="Cidade"
          item-text="dsc_lang"
          item-value="dsc_lang"
          placeholder="Selecione a cidade"
          :loading="$config.loading_cidades"
          :items="$config.cidades.result"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.cidade"
        >
        </BaseAutocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BaseTextField
          label="Data e hora do evento"
          type="datetime"
          v-mask="'##/##/#### ##:##'"
          placeholder="dd/mm/aaaa hh:mm"
          append-icon="mdi-calendar"
          persistent-hint
          :rules="dateRequired"
          :hint="apresentationDateExplain"
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.dthr_apresentacao
          "
        />
      </v-col>
      <v-col cols="6" v-if="isNotACourtesyProduct">
        <BaseSelect
          required
          label="Canais de Venda"
          item-text="value"
          item-value="key"
          placeholder="Selecione um canal de venda"
          :items="filtredSalesChannel"
          :rules="[rules.required]"
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.canal_venda"
        />
      </v-col>
      <v-col cols="6" v-if="!isNotACourtesyProduct">
        <v-checkbox
          hide-details
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.destaque"
          label="Produto em destaque"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
        >
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row v-if="isNotACourtesyProduct">
      <v-col cols="6">
        <v-checkbox
          hide-details
          v-model="$produtos_gerenciar.cadastro.dados_cadastrais.destaque"
          label="Produto em destaque"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
        >
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-checkbox
          hide-details
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.limitarIngressos
          "
          label="Limitar Ingressos por Consumidor"
          class="rounded-lg pa-2 mt-0"
          style="border: 1px solid rgb(0 0 0 / 42%)"
          active-class="active-class"
        >
        </v-checkbox>
      </v-col>
      <v-col cols="6">
        <BaseTextField
          label="Limitar ingressos por consumidor"
          placeholder="Ex: 5"
          type="number"
          min="1"
          v-model="
            $produtos_gerenciar.cadastro.dados_cadastrais.limite_venda_cpf
          "
          :disabled="!limitedTickets"
        />
      </v-col>
    </v-row>
    <ModalTraducoes />
    <DescriptionProduct />
  </fragment>
</template>
<script>
import mixins from "@/mixins";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import ModalTraducoes from "@/components/global/modal-traducoes.vue";
import DescriptionProduct from "@/components/produtos/gerenciar/DescriptionProduct.vue";

const { products, formRules } = mixins;

export default {
  name: "CommonProduct",
  mixins: [products, formRules],
  components: {
    BaseSelect,
    BaseMoneyField,
    BaseTextField,
    BaseAutocomplete,
    ModalTraducoes,
    DescriptionProduct,
  },
  data: () => ({
    descricao: "",
    descritivo: "",
    stockExplain:
      "ℹ️ Caso seu produto contenha mais de uma opção, o estoque será somado e apresentado aqui.",
    apresentationDateExplain:
      "ℹ️ Necessário informar uma data para o evento - essa data pode ser fixa (utilizar esse campo) ou variável (utilizar as opções do evento e incluir pelo menos uma opção de data).",
  }),
  methods: {
    openDescriptionModal() {
      this.$produtos_gerenciar.descriptionModal = true;
    },
    waitForEstadosResult() {
      return new Promise(resolve => {
        const checkEstados = () => {
          if (this.$config.estados && this.$config.estados.result) {
            resolve();
          } else {
            setTimeout(checkEstados, 50);
          }
        };
        checkEstados();
      });
    },
  },
  computed: {
    dateRequired() {
      const courtesyAndTicket =
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo ===
          "INGRESSO" ||
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "CORTESIA";
      const someProductWithOptionDate =
        this.$produtos_gerenciar.cadastro.variacoes.opcoes.some(item => {
          return item.tipo === "DATA";
        });

      return courtesyAndTicket && !someProductWithOptionDate
        ? [this.rules.required]
        : [];
    },
    descriptionIsNotEmpty() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descritivo !== ""
      );
    },
    statusPlaceholder() {
      if (this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo == "INGRESSO")
        return "Selecione o status do evento";
      return "Selecione o status do produto";
    },
    isCourtesyProduct() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "CORTESIA"
      );
    },
    manageStock() {
      return (
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos
          .length === 0 &&
        this.$produtos_gerenciar.cadastro.dados_cadastrais.gerenciar_estoque ===
          1
      );
    },
    limitedTickets() {
      return this.$produtos_gerenciar.cadastro.dados_cadastrais
        .limitarIngressos;
    },
    isNotACourtesyProduct() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo !== "CORTESIA"
      );
    },
    filtredSalesChannel() {
      return this.$produtos_gerenciar.canal_venda.filter(
        item => item.value !== "Cortesia"
      );
    },
  },
  watch: {
    "$produtos_gerenciar.cadastro.dados_cadastrais.pais": {
      handler(country) {
        const { id } = country;
        this.$config.getEstados(id || "9e1bf96ca2754ee6596f26fd6e6b5cc2");
      },
      deep: true,
      immediate: true,
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.estado": {
      async handler(state) {
        if (!state || !this.$config.estados) return;
        await this.waitForEstadosResult();

        const { id } = state;
        const filteredId = this.$config.estados.result.find(
          item => item.iso === state || item.id === id
        );
        if (filteredId) {
          await this.$nextTick();
          this.$config.getCidades(id || filteredId.id);
        } else {
          console.warn("State not found:", state);
        }
      },
      deep: true,
      immediate: true,
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br": function (
      e
    ) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.sku =
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo.substring(
          0,
          2
        ) +
        e.substring(0, 2).toUpperCase() +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.categoria
          .substring(0, 2)
          .toUpperCase() +
        Math.floor(Math.random() * 99999 + 1);
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.tipo": function (e) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.sku =
        e.substring(0, 2) +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br
          .substring(0, 2)
          .toUpperCase() +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.categoria
          .substring(0, 2)
          .toUpperCase() +
        Math.floor(Math.random() * 99999 + 1);
      if (e === "VOUCHER" || e === "RECARGA") {
        this.descricao = "Produto";
        this.descritivo = "Descrição";
        this.$produtos_gerenciar.cadastro.variacoes.gerenciar_lote = false;
      } else if (e === "INGRESSO" || e === "CORTESIA") {
        this.descricao = "Evento";
        this.descritivo = "Descrição do evento";
      } else {
        this.descricao = "Título do Produto";
      }
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.categoria": function (e) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.sku =
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo.substring(
          0,
          2
        ) +
        this.$produtos_gerenciar.cadastro.dados_cadastrais.descricao_pt_br
          .substring(0, 2)
          .toUpperCase() +
        e.substring(0, 2).toUpperCase() +
        Math.floor(Math.random() * 99999 + 1);
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.dthr_apresentacao"(e) {
      if (e == "") {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.dthr_apresentacao =
          null;
      }
    },
    "$produtos_gerenciar.cadastro.dados_cadastrais.limitarIngressos"(e) {
      if (e == false) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.limite_venda_cpf = 0;
      }
    },
  },
  mounted() {},
  destroyed() {
    this.$produtos_gerenciar.cadastro.dados_cadastrais.error.descritivo_pt_br = false;
  },
};
</script>
<style>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
.description-product {
  border: 2px solid red !important;
  background-color: white !important;
}
.desc::after {
  content: "*";
  color: red;
}
</style>
